import React from 'react'
import { ProfilePageContext } from 'context/profilePage/ProfilePageContext'
import { UserContext } from 'context'
import { validateConnectionExistsById } from '@/components/requestConnectionButton/validateConnectionSentReceived'

export const useProfilePage = () => {
  const { profile, setProfile, ownProfile } =
    React.useContext(ProfilePageContext)

  return { profile, setProfile, ownProfile }
}

export const useValidateUserRelation = (id: string) => {
  const { user } = React.useContext(UserContext)

  return React.useMemo(() => {
    if (!user || !user?.id) return {
      isConnection: false,
      isOwnProfile: false,
      isInvited: false,
      isInvitedBy: false,
    }
    if (user?.id === id ) {
      return {
        isConnection: false,
        isOwnProfile: true,
        isInvited: false,
        isInvitedBy: false,
      }
    }
    return {
      isConnection: user?.connections?.includes(id),
      isOwnProfile: false,
      isInvited: validateConnectionExistsById({
        id: id,
        connections: user.connectionsSent,
      }),
      isInvitedBy: validateConnectionExistsById({
        id: id,
        connections: user.connectionsReceived,
      }),
    }
  }, [user, id])
}
